import * as d3 from "d3";
import { wrapText, getLabelBounds } from "./helpers.js";
const drawRoleGroups = (container, rolesData, onDrag, onClick) => {
  rolesData.forEach((role) => {
    if (!role.size) {
      console.warn(`Role ${role.id} is missing a size property.`, role);
      role.size = { width: 60, height: 100 }; // Assign default size if missing
    }
  });

  const roleGroups = container
    .selectAll("g.role-group")
    .data(rolesData, (d) => d.id);

  const roleGroupsEnter = roleGroups
    .enter()
    .append("g")
    .attr("class", "role-group")
    .attr("data-class", "role")
    .attr("data-type", "role")
    .attr("data-id", (d) => d.id)
    .attr("cursor", "grab")
    .call(onDrag)
    .on("click", (event, d) => {
      //event.stopPropagation(); // Prevent event propagation
      console.log("Clicked on role", d);
      onClick(d);
    });

  roleGroupsEnter
    .append("rect")
    .attr("class", "role")
    .attr("rx", (d) => d.size.width / 20 || 0)
    .attr("ry", (d) => d.size.height / 20 || 0);

  roleGroupsEnter
    .merge(roleGroups)
    .attr(
      "transform",
      (d) => `translate(${d.position.x || 0}, ${d.position.y || 0})`
    )
    .on("click", (event, d) => {
      event.stopPropagation(); // Prevent event propagation
      console.log("Clicked on role", d);
      onClick(d);
    });

  // Add/Update labels for both new and existing groups
  roleGroupsEnter
    .merge(roleGroups)
    .selectAll("text.role-name")
    .data((d) => [d]) // Important: Wrap data in an array to ensure one text per group
    .join("text")
    .attr("class", "role-name")
    .attr("x", (d) => d.size.width / 2) // Center label within the role rectangle
    .attr("text-anchor", "middle")
    .attr("font-size", "18px")
    .attr("font-weight", "bold")
    .each(function (d) {
      const textElement = d3.select(this);
      textElement.selectAll("tspan").remove(); // Clear existing tspans

      const labelText = d.label || "new role";
      const maxWidth = d.size.width - 10;
      const lines = wrapText(labelText, maxWidth, 18);
      const isBelow = d.labelPosition === "below";

      // Calculate y position based on label position and number of lines
      let yPosition;
      if (isBelow) {
        // Position below the rectangle, accounting for multiple lines
        yPosition = d.size.height + (lines.length > 1 ? 20 : 15);
      } else {
        // Position above the rectangle (default behavior)
        yPosition = lines.length > 1 ? -26 : -18;
      }

      textElement.attr("y", yPosition);
      lines.forEach((line, index) => {
        textElement
          .append("tspan")
          .attr("x", d.size.width / 2)
          .attr("dy", index === 0 ? 0 : "1.2em") // First line: no offset, subsequent: 1.2em down
          .text(line);
      });
    });

  roleGroupsEnter
    .merge(roleGroups)
    .selectAll("text.role-tag-tick")
    .data((d) => (!d.transient ? [d] : [])) // Create a tick element only if transient is false
    .join("text")
    .attr("class", "role-tag-tick")
    .attr("x", (d) => {
      const labelBounds = getLabelBounds(d);
      return labelBounds.textEndX; // Position just after the text ends
    })
    .attr("y", (d) => {
      const labelBounds = getLabelBounds(d);
      // Position at the same level as the first line of the label
      return labelBounds.y + 10; // Slight offset to align with text baseline
    })
    .text("✔")
    .attr("font-weight", "bold")
    .attr("font-size", "30px");

  roleGroupsEnter
    .merge(roleGroups)
    .selectAll("text.role-tag-multiple")
    .data((d) => (d.multiple ? [d] : [])) // Create an 'n' element only if multiple is true
    .join("text")
    .attr("class", "role-tag-multiple")
    .attr("x", (d) => {
      const labelBounds = getLabelBounds(d);
      // Position after the tick mark if it exists, otherwise after the text
      const hasTickMark = !d.transient;
      if (hasTickMark) {
        return labelBounds.textEndX + 20; // After tick mark (✓ is about 30px wide)
      } else {
        return labelBounds.textEndX; // Just after the text
      }
    })
    .attr("y", (d) => {
      const labelBounds = getLabelBounds(d);
      // Position at the same level as the first line of the label
      return labelBounds.y + 12; // Slight offset to align with text baseline
    })
    .text("n")
    .attr("font-weight", "bold")
    .attr("font-size", "16px");

  roleGroupsEnter
    .merge(roleGroups)
    .select("rect.role")
    .attr("width", (d) => d.size.width)
    .attr("height", (d) => d.size.height);

  roleGroups.exit().remove();
};

export { drawRoleGroups };
